module.exports = __webpack_public_path__ + "img/safesky_simple.a14fb42b.png";